import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import moment from 'moment-timezone';

@Component({
  selector: 'app-custm-handbook',
  templateUrl: './custm-handbook.component.html',
  styleUrl: './custm-handbook.component.css',
  standalone: true,
  imports: [CommonModule]
})
export class CustmHandbookComponent implements OnInit {

  @Input() signature!: string;
  @Input() dateTimeSigned!: string;
  @Input() driverFullName!: string;
  signatureImagePath!: string;
  dateTimeSubmission!: string;
  driverName!: string;

  constructor (private route: ActivatedRoute) {
    
  }

  ngOnInit(): void {
    // this.route.queryParams.subscribe((params: any) => {
    //   const dateTimeSigned = params.dateadded;
    //   this.signatureImagePath = params.signature ?? '';
    //   this.dateTimeSubmission = dateTimeSigned ? moment(dateTimeSigned, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY hh:mm A') : '';
    //   this.driverName = params.fullname ?? '';
    // });
  }

  onErrorLoadImage () {
    return 'assets/common/image/white-wallpaper.png';
  }

}
